import {useQuery} from '@apollo/client';
import { GET_PRODUCT_VARIANTS } from '../../Queries/products';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { SERVER_URL,PRODUCT_IMAGE_URL } from '../../../../Config';

const UseGetAllVariants = (lang,productID) => {

    const [variables,SetVariables] = useState({
        lang,
        productID
    });

    const {t} = useTranslation();
    const [content,SetContent] = useState(null);
    const [selectedProductVariantIDs,SetSelectedProductVariantIDs] = useState([]);

    const {data,loading,error} = useQuery(GET_PRODUCT_VARIANTS,{
        variables,
        fetchPolicy:"network-only"
    })

    useEffect(() => {

        if(data)
        {
            const contentData = GetContentData(data.AllProductVariants);
            SetContent(contentData);
        }

    },[data])

    var headerData = [
        {
            value: "",
            className:"img-offset"
        },
        {
            value: t("ProductCode"),
            className:"flex-1"
        },
        {
            value: t("VariantName"),
            className:"flex-1"
        },
        {
            value: t("InternalNote"),
            className:"flex-1"
        }
    ];

    const GetContentData = (data) => {

        var contentData = [];

        for(let val of data)
        {
            var cData = {
                data:[
                    {
                        elm:"img",
                        src: val.photo ? SERVER_URL + "/" + PRODUCT_IMAGE_URL + "/p-" + productID + "/Variants/mala_" + val.photo : "",
                        className:"no-padding-right"
                    },
                    {
                        value:val.productCode,
                        className:"flex-1"
                    },
                    {
                        value:val.name,
                        className:"flex-1"
                    },
                    {
                        value:val.internalNote,
                        className:"flex-1"
                    }
                ],
            }

            cData.rowID    = val.productVariantID;
            cData.selected = false;

            contentData.push(cData)
        }
        return contentData;
    }

    const SelectRow = (e,productVariantID) => {

        var checked = e.target.checked;
        var newSelectedProductVariantIDs = [...selectedProductVariantIDs];
        const newList = SelectProductVariantID(content,productVariantID,checked,newSelectedProductVariantIDs)

        SetContent(newList);
        SetSelectedProductVariantIDs(newSelectedProductVariantIDs);
    }

    const SelectAll = (e) => {

        var checked = e.target.checked;
        var newSelectedProductVariantIDs = [];
        const newList = SelectProductVariantID(content,"all",checked,newSelectedProductVariantIDs)

        SetSelectedProductVariantIDs(newSelectedProductVariantIDs);
        SetContent(newList);
    }

    const SelectProductVariantID = (list,productVariantID,checked,selectedProductVariantIDs) => {

        const newList = [...list];
        for(let i = 0; i < newList.length; i++)
        {
            if(productVariantID == newList[i].rowID || productVariantID === "all")
            {
                newList[i] = {...newList[i],selected:checked}
                if(checked)
                    selectedProductVariantIDs.push(newList[i].rowID);
                else
                {
                    for(let j = 0; j < selectedProductVariantIDs.length; j++)
                    {
                        if(selectedProductVariantIDs[j] == newList[i].rowID)
                            selectedProductVariantIDs.splice(j,1);  
                    } 
                }
            }

            if(newList[i].subData)
                newList[i] = {...newList[i],subData:SelectProductVariantID(newList[i].subData,productVariantID,checked,selectedProductVariantIDs)}
        }

        return newList;
    }

    return{
        content,
        headerData,
        loading,
        error,
        selectedProductVariantIDs,
        SelectRow,
        SelectAll
    }

}

export default UseGetAllVariants;